function onReady(callback) {
    var intervalID = window.setInterval(checkReady, 1000);

    function checkReady() {
        if (document.getElementsByTagName("body")[0] !== undefined) {
            window.clearInterval(intervalID);
            callback.call(this);
        }
    }
}

function show(selector, value) {
    if (value) {
        $(selector).fadeIn();
    } else {
        $(selector).fadeOut();
    }
}

onReady(function() {
    show(".preloader", false);
});
$( document ).ajaxSend(function() {
    let body = $('body');
    if(!body.hasClass('no-loader')) {
        if(!body.hasClass('no-loader-page')) {
            if($('.modal-backdrop').length) {
                $('.modal-backdrop').css('opacity', 0);
            }
            show('.preloader', true);
        }
    }
});
$( document ).ajaxStop(function(e) {
    $.fn.dataTable.ext.errMode = 'none';
    let body = $('body');
    if(!body.hasClass('no-stop-loader')) {
        show('.preloader', false);
        body.removeClass('no-loader');
    }
});
$(document).ajaxError(function(event, request, settings) {
    if (request.status == 419) {
        let pathname = window.location.pathname.split("/")[1];
        switch (pathname) {
            case "admin":
                location.href = "/admin/login";
                break;
            default:
                location.href = "/login";
        }
    }
});
